// PAM 2026-06-09 — Popup ajout au panier avec image produit
(function ($) {
  'use strict';

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function showCartModal(item) {
    var existing = document.getElementById('pam-cart-modal');
    if (existing) existing.remove();

    var cartUrl = (typeof theme !== 'undefined' && theme.routes && theme.routes.cart_url) ? theme.routes.cart_url : '/cart';
    var checkoutUrl = '/checkout';

    var imgSrc = '';
    if (item.image) {
      imgSrc = item.image.replace(/^\/\//, 'https://');
    } else if (item.featured_image && item.featured_image.url) {
      imgSrc = item.featured_image.url.replace(/^\/\//, 'https://');
    }

    var modal = document.createElement('div');
    modal.id = 'pam-cart-modal';
    modal.innerHTML =
      '<div class="pam-modal__overlay"></div>' +
      '<div class="pam-modal__box">' +
        '<button class="pam-modal__close" aria-label="Fermer">&times;</button>' +
        '<div class="pam-modal__content">' +
          (imgSrc ? '<div class="pam-modal__img-wrap"><img src="' + imgSrc + '" alt="' + item.title + '"></div>' : '') +
          '<div class="pam-modal__info">' +
            '<p class="pam-modal__label">A ÉTÉ AJOUTÉ À VOTRE PANIER!</p>' +
            '<p class="pam-modal__title">' + item.quantity + ' ' + item.title + '</p>' +
            '<p class="pam-modal__price">' + formatMoney(item.price) + '</p>' +
            '<a class="pam-modal__btn pam-modal__btn--primary" href="' + checkoutUrl + '">Procéder au Paiement</a>' +
            '<a class="pam-modal__btn pam-modal__btn--secondary" href="' + cartUrl + '">Voir le Panier</a>' +
          '</div>' +
        '</div>' +
      '</div>';

    document.body.appendChild(modal);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        modal.classList.add('pam-cart-modal--visible');
      });
    });

    function close() {
      modal.classList.remove('pam-cart-modal--visible');
      setTimeout(function () {
        if (modal.parentNode) modal.parentNode.removeChild(modal);
      }, 350);
    }

    modal.querySelector('.pam-modal__close').addEventListener('click', close);
    modal.querySelector('.pam-modal__overlay').addEventListener('click', close);
  }

  $(document).on('ajaxSuccess', function (event, xhr, settings) {
    if (settings.url && settings.url.indexOf('cart/add') !== -1) {
      try {
        var item = JSON.parse(xhr.responseText);
        if (item && item.title) showCartModal(item);
      } catch (e) {}
    }
  });

})(jQuery);
